<section class="video-section" [ngStyle]="styles">
    <div class="container d-flex justify-content-center">
        <div class="video">
            <iframe width="700px" height="400" [src]="'https://www.youtube.com/embed/' + getVideoId() | safe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
    </div>
</section>